import {
  Box,
  Button,
  Grid,
  // IconButton,
  TextField,
  Typography,
} from "@mui/material";
import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import Images from "../../assets";
// import { useAppDispatch } from "../../assets/hooks";
// import { CustomButton } from "../../genericComponents/customButton";
import { authenticateLogin, verifyUserOtp } from "../../services";
import * as Yup from "yup";
// import CustomField from "../../genericComponents/customTextfield";
// import { closePopup, setPopup } from "../../store/Slices/popupSlice";
import { checkUser } from "../../assets/library";
import OTPInput from "./otpInput";
// import { secondaryButton } from "../styles/customStyles";
// import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { useNavigate } from "react-router-dom";

const LoginComp = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  // const dispatch = useAppDispatch();
  const [loginMethod, setLoginMethod] = useState<any>('initial');
  // const [phone, setPhone] = useState({
  //   countryCode: "",
  //   phoneNumber: "",
  // });

  const [email, setEmail] = useState("");
  const initValues = {
    email: email,
  };
  const loginSchema = Yup.object().shape({
    email: Yup.string()
      .matches(
        /([a-z0-9]+)([{1}])?([a-zA-Z0-9]+)([a-zA-Z0-9]+)([a-z]+)/g,
        "Enter valid Email"
      )
      .required("Enter Email")
      .max(40, "Email must be atmost 40 characters"),
  });
  const otpSchema = Yup.object().shape({
    otp: Yup.string()
      .required("Required")
      .matches(/^[0-9]+$/, "Must be only digits")
      .min(6, "Must be exactly 6 digits")
      .max(6, "Must be exactly 6 digits"),
  });
  // const [selectedOption, setSelectedOption] = useState<string>("");

  const [timer, setTimer] = useState<any>(60); // 2 minutes in seconds
  const [canRetry, setCanRetry] = useState(false);

  const onSubmitForm = async (values: any) => {
    setLoading(true);
    try {
      const response = await authenticateLogin(values);
      if (response.data.success) {
        setLoginMethod("verify");
        // setTimer(60); // Start the timer at 60 seconds
        setCanRetry(false); // Disable retry button initially
        setLoading(false);
      }
    } catch (err) {
      console.log(err);
      setLoading(false);

    }
  };

  useEffect(() => {
    if (timer > 0 && loginMethod === "verify") {
      const countdown = setInterval(() => {
        setTimer((prevTime: any) => prevTime - 1);
      }, 1000);
      return () => clearInterval(countdown);
    } else if (timer === 0) {
      setCanRetry(true);
    }
  }, [timer, loginMethod]);

  const formatTime = (seconds: number) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = seconds % 60;
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

  // Handle retry button click
  const handleRetry = () => {
    setTimer(180);
    setCanRetry(false);
    onSubmitForm({ email: email });
  };
  const verifyCodeSubmit = async (values: any) => {
    setLoading(true);
    
    let emailOtp = {
      otp: values.otp,
      email: email,
      type: "email"
    }
    try {
      const response = await verifyUserOtp(emailOtp);
      if (response?.data?.success === true) {
        localStorage.setItem("_auth_token", response?.data?.data?.AccessToken);
        localStorage.setItem("role", response?.data?.data?.role);
        checkUser();
        navigate("/dashboard");
        window.location.reload()

      } else {
      }
    } catch (error) {
    }
    setLoading(false);
  };

  // const handlePhoneChange = (value: string, data: any) => {
  //   const dialCode = data?.dialCode || "";
  //   const enteredCountryCode = dialCode.trim();
  //   if (value.startsWith(enteredCountryCode)) {
  //     setPhone({
  //       countryCode: "+" + enteredCountryCode,
  //       phoneNumber: value.slice(enteredCountryCode.length).trim()
  //     });
  //   } else {
  //     const codeSplit = "+" + value.split(dialCode);
  //     const enteredPhoneNumber = codeSplit.length > 1 ? codeSplit[1].trim() : "";
  //     setPhone({
  //       countryCode: enteredCountryCode,
  //       phoneNumber: enteredPhoneNumber
  //     });
  //   }
  // };


  // const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSelectedOption((event.target as HTMLInputElement).value);
  //   setLoginMethod(event.target.value)
  // };


  // useEffect(() => {
  //   if (timer > 0 && loginMethod === "verify") {
  //     const countdown = setInterval(() => {
  //       setTimer((prevTime) => prevTime - 1);
  //     }, 1000);
  //     return () => clearInterval(countdown);
  //   } else {
  //     setCanRetry(true);
  //   }
  //   // eslint-disable-next-line
  // }, [timer]);

  // const formatTime = (seconds: number) => {
  //   const minutes = Math.floor(seconds / 60);
  //   const remainingSeconds = seconds % 60;
  //   return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  // };

  // const handleRetry = () => {
  //   setTimer(120); // Reset the timer to 2 minutes
  //   setCanRetry(false); // Disable the retry button
  //   onSubmitForm(phone)

  // };



  return (
    <Box sx={{ height: "100%" }}>
      <Grid container sx={{ justifyContent:"center",alignItems:"center",height:"100%" }}>
  
        <Grid item xs={12} md={6.5} sx={{padding:"2rem", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center",background: "#d1d3f933",borderRadius:"10px" }}>
          <Box sx={{ px: { xs: 2, sm: 4 }, width: "80%", my: { sm: 3, md: 0 } }}>
            <Box sx={{ mb: 1.5, display: "flex", justifyContent: "center", position: "relative" }}>
              <Box component="img" src={Images.oneWindow} alt="logo" sx={{ width: { xs: "120px", md: "180px" } }} />
              {/* <img src={Images.flightRight} alt="flight" style={{ width: "3.5rem", height: "3.5rem", position: "absolute", left: "-25px" }} />
              <Box component="img" src={Images.passport} alt="flight" sx={{ width: "35px", height: "35px", position: "absolute", right: "-35px", top: { xs: "-60px", sm: "-15px", md: "-60px" } }} /> */}
            </Box>

            <Grid container >
              <Grid item xs={12} sx={{}}>
                <Typography sx={{ textAlign: "center", fontSize: "1.25rem", fontWeight: "500" }}>Sign up or Login</Typography>
              </Grid>
              <Grid item xs={12} sx={{ height: "250px" }}>

                {loginMethod === "initial" ?
                  <Box sx={{ textAlign: 'center', padding: 3, display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center" }}>
                   <Formik
                          initialValues={initValues}
                          validationSchema={loginSchema}
                          onSubmit={(values: any) => onSubmitForm(values)}
                          enableReinitialize={true}
                        >
                          {({ errors, touched, values, handleChange }) => (
                            <Form >
                              <Grid container spacing={1.25} >
                                <Grid item xs={12} sx={{}}>
                                  <TextField
                                    id="email"
                                    name="email"
                                    type="email"
                                    size="small"
                                    label="Email *"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                    error={touched.email && Boolean(errors.email)}
                                    fullWidth
                                    sx={{
                                      "&::placeholder": {
                                        color: "#000 !important"
                                      },
                                      '& .MuiOutlinedInput-root .Mui-error': {
                                        '& fieldset': {
                                          borderColor: 'red',
                                        },
                                      },
                                    }}
                                  />
                                  <div style={{ color: "#e60c0c", fontSize: "12px",textAlign:"start",marginTop:"4px" }}>
                                    <ErrorMessage name="email" component="div" />
                                  </div>
                                </Grid>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                  <Button
                                    sx={[{ width: "100px",border:"1px solid #3b3f76",textTransform:"none",color:"#3b3f76",borderRadius:"15px" }]}
                                    type="submit">
                                    {loading ? (
                                      <img
                                        src={Images.standardLoader}
                                        alt="load"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          padding: "5px",
                                        }}
                                      />
                                    ) : (
                                      "Continue"
                                    )}
                                  </Button>

                                </Grid>

                              </Grid>
                            </Form>
                          )}
                        </Formik>
                    
                  </Box>
                  :
                  loginMethod === "verify" ?
                      <Box sx={{ }}>
                        <KeyboardBackspaceIcon sx={{ color: "grey", cursor: "pointer", mb: 1.5 }} onClick={() => setLoginMethod("initial")} />
                        <Typography
                          sx={{
                            fontSize: { xs: "18px" },
                            fontWeight: 500,
                            mb:1
                          }}
                        >
                          OTP verification{" "}
                        </Typography>
                        <Typography sx={{ fontSize: "14px", fontWeight: "400" }}>
                          {`Please enter the otp we have sent to your email ${email}`}
                        </Typography>
                        <Formik
                          initialValues={{
                            otp: "",
                            // phone,
                          }}
                          validationSchema={otpSchema}
                          onSubmit={verifyCodeSubmit}
                        >
                          {({ values, handleChange }) => {
                            return (
                              <Form
                                style={{
                                  marginTop: "1rem",
                                  display: "flex",
                                  flexDirection: "column",
                                  justifyContent: "center",
                                  // padding:"0 1.5rem"
                                }}
                              >
                                <OTPInput
                                  length={6}
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-evenly",
                                    marginBottom: "20px",
                                  }}
                                  name="otp"
                                  isNumberInput
                                  autoFocus
                                  inputClassName="otpinput"
                                  value={values.otp}
                                  onChangeOTP={(otp: any) => (values.otp = otp)}
                                />
                                <div style={{ color: "#e60c0c", fontSize: "12px", marginLeft: "20px" }}>
                                  <ErrorMessage
                                    name="otp"
                                    component="div"
                                    className="error"
                                  // style={{ color: "#e60c0c", fontSize: "12px" }}
                                  />
                                </div>
                                <div style={{ textAlign: 'center', margin: '10px 0' }}>
                                  {canRetry ? (
                                    <span onClick={handleRetry} style={{ color: "#03a9f4" }}>Retry</span>
                                  ) : (
                                    <span>Retry available in {formatTime(timer)} minutes.</span>
                                  )}
                                </div>
                                <Box sx={{ mb: 2, display: "flex", justifyContent: "center" }}>
                                  <Button
                                    onClick={() => console.log("")}
                                    sx={{ width: "100px",border:"1px solid #3b3f76",textTransform:"none",color:"#3b3f76",borderRadius:"15px"}}
                                    type="submit"
                                  >
                                    {loading ? (
                                      <img
                                        src={Images.standardLoader}
                                        alt="load"
                                        style={{ width: "20px", height: "20px", padding: "5px" }}
                                      />
                                    ) : (
                                      "Continue"
                                    )}
                                  </Button>
                                </Box>
                              </Form>
                            );
                          }}
                        </Formik>
                      </Box> :
                      <Box sx={{ mt: 4 }}>
                        <KeyboardBackspaceIcon sx={{ color: "grey", cursor: "pointer", mb: 1.5 }} onClick={() => setLoginMethod("initial")} />
                        <Formik
                          initialValues={initValues}
                          validationSchema={loginSchema}
                          onSubmit={(values: any) => onSubmitForm(values)}
                          enableReinitialize={true}
                        >
                          {({ errors, touched, values, handleChange }) => (
                            <Form >
                              <Grid container spacing={1.25} >
                                <Grid item xs={12} sx={{}}>
                                  <TextField
                                    id="email"
                                    name="email"
                                    type="email"
                                    size="small"
                                    label="Email *"
                                    placeholder="Enter email"
                                    value={email}
                                    onChange={(e: any) => setEmail(e.target.value)}
                                    error={touched.email && Boolean(errors.email)}
                                    fullWidth
                                    sx={{
                                      "&::placeholder": {
                                        color: "#000 !important"
                                      },
                                      '& .MuiOutlinedInput-root .Mui-error': {
                                        '& fieldset': {
                                          borderColor: 'red',
                                        },
                                      },
                                    }}
                                  />
                                  <div style={{ color: "#e60c0c", fontSize: "12px" }}>
                                    <ErrorMessage name="email" component="div" />
                                  </div>
                                </Grid>
                                <Grid item xs={12} sx={{ display: "flex", justifyContent: "center", mt: 2 }}>
                                  <Button
                                    sx={[{ width: "200px" }]}
                                    type="submit">
                                    {loading ? (
                                      <img
                                        src={Images.standardLoader}
                                        alt="load"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          padding: "5px",
                                        }}
                                      />
                                    ) : (
                                      "Continue"
                                    )}
                                  </Button>

                                </Grid>

                              </Grid>
                            </Form>
                          )}
                        </Formik>
                      </Box>

                }
              </Grid>


            </Grid>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};
const Login = () =>{
  return(
    <div>
      <Grid container>
      <Grid item sm={6} sx={{ display: { xs: "none", sm: "block" } }}>
          <img
            src={Images.counsellor}
            alt="counsellor-illustration"
            style={{ height: "99.5vh", width: "-webkit-fill-available" }}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <LoginComp/>
        </Grid>
      </Grid>
    </div>
  )
}

export default Login;
